export default __webpack_public_path__ + "static/media/mortgage.d3464753.png";